import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export const calendarTradeSalesOrdersQueryAtom = createQueryAtomFactory(
  'calendar.tradeSalesOrders',
  (params: { fromDate: string; toDate: string; facilityId?: string }) => {
    const filter: Record<string, unknown> = {
      fromStartDate: params.fromDate,
      toStartDate: params.toDate,
    };

    if (params.facilityId) {
      filter.facilityIds = [params.facilityId];
    }

    return {
      salesOrders: {
        __args: {
          filter,
          pagination: {
            limit: 500,
            offset: 0,
          },
        },
        entries: {
          id: true,
          documentNumber: true,
          status: true,
          startDate: true,
          endDate: true,
          facilityId: true,
          facility: {
            id: true,
            facilityName: true,
          },
        },
        page: {
          total: true,
        },
      },
    };
  },
);
